@if (!showTrustComputer) {
  <div class="step-counter">
    Step {{ isAuthenticator ? '3 of 4' : '2 of 3' }}
  </div>
}

<div class="message">
  @if (isAuthenticator) {
    @if (showTrustComputer) {
      Enter the code displayed in your authenticator app below.
    } @else {
      Finish setting up your authenticator app by typing in the validation code
      displayed on your app.
    }
  } @else {
    We sent a code to {{ display }} that will expire in 15 minutes.
    Please enter it below.
  }
</div>

<div class="form-group"
     [formGroup]="form">
  <mat-form-field appearance="outline">
    <mat-label>Code</mat-label>

    <input matInput
           id="verification-code"
           formControlName="verificationCode"
           required
           autofocus>

    <mat-error>
      @if (form.controls['verificationCode'].hasError('required') || form.controls['verificationCode'].hasError('pattern')) {
        Verification code is required and must be 6 digits.
      } @else if (form.controls['verificationCode'].hasError('invalid')) {
        Verification code entered is invalid.
      }
    </mat-error>
  </mat-form-field>

  @if (!isAuthenticator) {
    <div class="resend">
      Didn't get it?

      <a mat-stroked-button
         href="./VerificationCode?isResend=true"
         id="btnResend">Resend code</a>
    </div>
  }

  @if (showTrustComputer) {
    <div>
      <mat-checkbox id="trust-this-computer" formControlName="trustThisComputer">Trust this computer</mat-checkbox>

      <div class="inset-left">
        <small>Uncheck if this is a public or shared computer.</small>
      </div>
    </div>
  }

  @if (isInvalid) {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>
      <div class="error-text">{{ errorMessage }}</div>
    </div>
  }

  <div class="buttons">
    <a mat-button
       href="./Back?verificationType={{ verificationTypeString }}">Back</a>

    <button mat-flat-button
            id="btnSend"
            color="primary"
            type="submit"
            (click)="submitForm()">Next</button>
  </div>
</div>
